<template>
  <div class="login-box">
    <img class="img-bj" src="@/assets/img/images/login-bj.png" />
    <div class="login-form-box">
      <p class="p1">重置登录密码</p>
      <el-form>
        <el-form-item label="创建新密码" prop="password">
          <el-input
            v-model="formData.password"
            :type="showPassword ? '' : 'password'"
             :placeholder="$t('tipsVal.inputPlaceholder')"
          >
            <template slot="suffix">
              <img
                v-if="!showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye1.png"
              />
              <img
                v-if="showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye2.png"
              />
            </template>
          </el-input>
        </el-form-item>
        <div class="tip-box">至少 8 个字符并且存有数字字母</div>
        <el-form-item label="确认您的密码" prop="password">
          <el-input
            v-model="formData.password"
            :type="showPassword ? '' : 'password'"
             :placeholder="$t('tipsVal.inputPlaceholder')"
          >
            <template slot="suffix">
              <img
                v-if="!showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye1.png"
              />
              <img
                v-if="showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye2.png"
              />
            </template>
          </el-input>
        </el-form-item>
        <el-button class="login-btn">确认</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      checked: false,
      showPassword: false,
      currTab: "手机号注册",
      formData: { name: "", password: "" },
    };
  },
  mounted() {},
  methods: {
    tabChange(val) {
      this.currTab = val;
    },
  },
};
</script>

<style lang="less" scoped>
.login-box {
  width: 100%;
  display: flex;
  position: relative;
  background: #f5f6f7;
  justify-content: center;
  height: calc(100% - 120px);
  .img-bj {
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    position: absolute;
  }
  .login-form-box {
    z-index: 2;
    width: 680px;
    margin-top: 60px;
    height: fit-content;
    position: relative;
    padding: 60px 88px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    /deep/ .el-form{
      margin-top: 40px;
    }
    .p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 40px;
      color: #333333;
    }
    .code-box {
      display: flex;
      gap: 16px;
    }
    .login-btn {
      background: var(--primary-color);
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 32px;
    }
    .title-box {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: var(--primary-color);
      }
    }
    /deep/.el-input-group--append {
      gap: 16px;
      display: flex;
    }
    /deep/.el-input-group__append {
      cursor: pointer;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid var(--primary-color);
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: var(--primary-color);
      padding: 0 24px;
      width: auto;
      display: flex;
      align-items: center;
    }
    /deep/.is-checked .el-checkbox__inner {
      background: var(--primary-color);
    }
    /deep/.is-checked .el-checkbox__inner::after {
      width: 0;
      height: 0;
      border: none;
    }
    /deep/.el-checkbox__inner {
      border-radius: 50%;
    }
    /deep/ .el-input__suffix,
    /deep/ .el-input__suffix-inner {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tip-box {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      margin-top: -16px;
      margin-bottom: 20px;
    }
    .eye-img {
      width: 25px;
      height: 25px;
      margin-right: 6px;
    }
    .tab-box {
      gap: 40px;
      display: flex;
      margin-top: 20px;
      margin-bottom: 10px;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding-bottom: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }
      .sel {
        font-weight: 800;
        font-size: 16px;
        color: var(--primary-color);
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 1px solid var(--primary-color);
      }
    }
  }
}
</style>
